import React, {Component} from 'react';
import ReportModulesContainer from '../../../containers/report_module_container';
import {Button, Grid, Header, Icon, Input, Message, Popup, Segment} from "semantic-ui-react";
import CKEditor from "react-ckeditor-component";
import {getModuleDetail} from "../../../data/report_module_api";
import Loader from '../../universal/loader';

class ReportModules extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedModule: undefined,
            message: undefined,
            showNameEdit: false,
            updateModuleName: undefined,
            updateModuleContent: undefined,
            updated: false,
            deleted: undefined,
            isFetching:false
        }
    }

    componentWillMount() {
        this.props.getModulesList();
    }

    handleModuleSelect = (selectedModule) => {
        this.setState({selectedModule:undefined,isFetching:true});
        getModuleDetail(selectedModule.id).then((module)=>{
            this.setState({
                selectedModule: module,
                updated: false,
                updateModuleName: module.name,
                updateModuleContent: module.contents,
                isFetching:false
            })
        })

    };

    handleEditorUpdate = () => {
        this.setState({updated: true})
    };

    handleContentChange = (e) => {
        let newContent = e.editor.getData();
        this.setState({updateModuleContent: newContent});
    };

    handleSubmit = () => {
        const formData = {
            name: this.state.updateModuleName,
            id: this.state.selectedModule.id,
            contents: this.state.updateModuleContent,
            type: 1
        };
        this.props.updateModule(formData, this.successCallBack);
    };

    successCallBack = (response) => {
        if (response.success) {
            this.setState({message: true, updated: false});
            setTimeout(() => {
                this.setState({message: undefined})
            }, 5000)
        }
    };

    handleDeleteModule = (id) => {
        this.props.deleteModule(id, this.deleteInfo);

    };

    deleteInfo = (response) => {
        if (response.success) {
            this.setState({deleted: true, selectedModule: undefined});
        }
    };

    render() {
        const modules = this.props.modules['custom_modules'];
        return (<div style={{width: "90%", margin: 'auto', paddingTop: '2%'}}>
            <Header size="large" textAlign="left">
                <span>Report Modules  </span><span><Button primary onClick={() => {
                this.props.history.push('/report/module/create')
            }}>Add New Module</Button></span>
            </Header>
            {this.state.message === true && <Message positive onDismiss={() => {
                this.setState({message: undefined})
            }}><span className="format-bold">Successfully Updated module!</span></Message>}
            {this.state.message === false && <Message negative onDismiss={() => {
                this.setState({message: undefined})
            }}><span className="format-bold">An Error Occurred. Please, Try again!</span></Message>}
            {this.state.deleted === true && <Message positive onDismiss={() => {
                this.setState({deleted: undefined})
            }}><span className="format-bold">Module Deleted Successfully !</span></Message>}
            {this.state.deleted === false && <Message negative onDismiss={() => {
                this.setState({deleted: undefined})
            }}><span className="format-bold">Module Deleted Successfully !</span></Message>}
            {this.state.updated && <Message info onDismiss={() => {
                this.setState({updated: false})
            }}><span className="format-bold">You have unsaved changes made to this module. click on save module to save the changes</span></Message>}

            <Grid style={{maxHeight: window.screen.height * 0.60}}>
                <Grid.Column width={5} style={{maxHeight: '90%', overflowY: 'scroll'}}>
                    {modules && modules.length > 0 ? <Segment.Group>
                        {modules.map((module, i) => {
                                return (<Segment key={i}>
                                    <div style={{display: 'table'}}>
                                        <span style={{
                                            display: 'table-cell',
                                            width: '80%',
                                            verticalAlign: 'middle'
                                        }}>{module.name}</span>
                                        <span style={{display: 'table-cell'}}><Button primary content={"View"}
                                                                                      className="pull-right"
                                                                                      onClick={() => {
                                                                                          this.handleModuleSelect(module)
                                                                                      }}/></span>
                                    </div>
                                </Segment>)
                            }
                        )}
                    </Segment.Group> : <Segment><span>No Modules Found</span></Segment>}
                </Grid.Column>
                <Grid.Column width={11}>
                    {this.state.isFetching && <Loader/>}
                    {!this.state.isFetching && this.state.selectedModule ?
                        <div>
                            <Header>
                                {!this.state.showNameEdit && <div><span className="format-capitalize" onClick={(e) => {
                                    this.setState({showNameEdit: true})
                                }}>{this.state.updateModuleName}</span><span className="pull-right"><Popup
                                    trigger={<Icon name="trash"
                                                   size='large'
                                                   color='red'
                                                   className="icon-button"
                                    />}
                                    content={<Button negative content="Confirm Delete Module?"
                                                     onClick={(e) => {
                                                         this.handleDeleteModule(this.state.selectedModule.id)
                                                     }}/>}
                                    on="click"
                                    position="top center"
                                    hideOnScroll
                                /></span></div>}
                                {this.state.showNameEdit && <div>
                                    <Input type='text'
                                           defaultValue={this.state.updateModuleName}
                                           autoFocus
                                           onChange={(e) => {
                                               this.setState({updateModuleName: e.target.value})
                                           }}
                                           onFocus={(e) => {
                                               this.setState({updateModuleName: e.target.value})
                                           }}
                                           onBlur={() => {
                                               this.setState({showNameEdit: false, updated: true})
                                           }}/>
                                </div>}
                            </Header>
                            <CKEditor
                                activeClass="p10"
                                content={this.state.updateModuleContent}
                                events={{
                                    "change": this.handleContentChange,
                                    "blur": this.handleEditorUpdate
                                }}
                                scriptUrl={"//cdn.ckeditor.com/4.10.0/full/ckeditor.js"}
                                config={{
                                    toolbarGroups: [
                                        {name: 'document', groups: ['mode', 'document', 'doctools']},
                                        {name: 'clipboard', groups: ['clipboard', 'undo']},
                                        {name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing']},
                                        {name: 'forms', groups: ['forms']},
                                        {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
                                        {
                                            name: 'paragraph',
                                            groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']
                                        },
                                        {name: 'links', groups: ['links']},
                                        {name: 'insert', groups: ['insert']},
                                        {name: 'styles', groups: ['styles']},
                                        {name: 'colors', groups: ['colors']},
                                        {name: 'tools', groups: ['tools']},
                                        {name: 'others', groups: ['others']},
                                        {name: 'about', groups: ['about']}
                                    ],
                                    removeButtons: 'Print,Save,Templates,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Language,Flash,Smiley,Iframe,ShowBlocks,About',
                                    height: (window.screen.height * 0.38)
                                }}
                            />
                            <div className="pad-top">
                                <Button className="pull-right" primary onClick={() => {
                                    this.handleSubmit()
                                }} content="Save Module"/>
                            </div>
                        </div> :
                        <p className="center-aligned"> No Module selected to View</p>}
                </Grid.Column>
            </Grid>
        </div>)
    }
}

export default ReportModulesContainer(ReportModules)


// WEBPACK FOOTER //
// ./src/views/report/modules/index.js